import React from "react";
import {Navigate, Outlet, useSearchParams} from "react-router-dom";

export default function PrivateRoute({isAuthenticated, redirectPath = "/sign-in"}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const contentNudge = searchParams.get("cn");

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace state={contentNudge ? {cn: contentNudge} : {}} />;
  }

  return <Outlet />;
}
